export default __webpack_public_path__ + "static/media/Send_msg.b3d00735.svg";